export const MARKETING_URL_PARAMS_CACHE_DAYS = 7;

export const MARKETING_URL_PARAM_NAMES: string[] = [
  'device',
  'network',
  'refer',
  'sourcename',
  'sourcetype',
  'campaignid',
  'adgroupid',
  'contractor_uuid',
  'document_id',
  'loan_amount',
  'contractor_name',
];

export const GET_CONCEPTUAL_DEVICE_ID_MAX_ATTEMPTS = 10;
export const GET_CONCEPTUAL_DEVICE_ID_RETRY_DELAY_MS = 300;
export const CONCEPTUAL_DEVICE_ID_COOKIE = '_ca_device_id';
